import { GetIssuedPremiumsParams, reportsService } from '@/services';
import { useQuery } from '@tanstack/react-query';

/** Só os filtros — os cards independem de página/ordenação. */
type SummaryFilters = Pick<
  GetIssuedPremiumsParams,
  | 'issueDateFrom'
  | 'issueDateTo'
  | 'advisoryPartyCode'
  | 'brokerPartyCode'
  | 'productCode'
  | 'branchCode'
  | 'statusCode'
>;

/**
 * Cards totalizadores. A queryKey depende SÓ dos filtros, então paginar ou
 * ordenar o grid não recalcula a agregação pesada (React Query serve do cache).
 */
export function useIssuedPremiumsSummary(filters: SummaryFilters) {
  const enabled = Boolean(filters.issueDateFrom && filters.issueDateTo);

  return useQuery({
    queryKey: ['issued-premiums-summary', filters],
    enabled,
    queryFn: async () => {
      const response = await reportsService.getIssuedPremiumsSummary(filters);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Não foi possível carregar os totalizadores.');
      }
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}
